// dashbaord
import Default from "../components/dashboard/default";
import PaymentSuccess from "../components/dashboard/payment-success";

export const routes = [
    { path: `${process.env.PUBLIC_URL}/`, Component: Default },
    {
        path: `${process.env.PUBLIC_URL}/payment-success/:id`,
        Component: PaymentSuccess,
    },
];
